import { FC } from "react";
import { ContactDetails } from "./ContactDetails";
import { PaymentDetails } from "./PaymentDetails";
import { TermsAndConditions } from "./TermsAndConditions";
import { RedsysInPagePayment } from "./RedsysInPagePayment";
import { useApp } from "../../context/useApp";
import { load } from "../../utils/helpers";
import { captureException } from "@sentry/react";
import { Journeys } from "../../types";

interface PersonalDetailsFormProps {
    insideElements?: boolean
    setStripeComplete: React.Dispatch<React.SetStateAction<boolean>>
    clientSecret?: string
    journey: Journeys
}

export const PersonalDetailsForm: FC<PersonalDetailsFormProps> = ({
    setStripeComplete,
    clientSecret,
    insideElements = false,
    journey
}) => {

    const { state: { booking, shifts } } = useApp()
    const shift = shifts.find(s => s.id === booking.shiftId)
    const isFormValid = shift ? booking.validatePersonalDetail({shift}).length === 0 : false

    

    return (
        <form id="personal-details-form" className="w-100 mr-13" onSubmit={e => e.preventDefault()}>
            <ContactDetails />
            {insideElements && clientSecret && (<PaymentDetails clientSecret={clientSecret}/>)}
            {isFormValid && journey === "B" && booking.acceptedTerms && <RedsysInPagePayment />}
            <TermsAndConditions />
        </form>
    )
}